import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "section content-container" }
const _hoisted_3 = { class: "container is-fluid" }
const _hoisted_4 = { class: "island" }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Contacts',
  setup(__props) {

const isLoading = ref(true);

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("section", { class: "section primary-header" }, [
      _createElementVNode("div", { class: "container is-fluid" }, [
        _createElementVNode("h1", { class: "title is-2" }, "Contacts"),
        _createElementVNode("h2", { class: "subtitle" }, "View, filter, search, and segment your leads and users")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view, {
            onLoaded: _cache[0] || (_cache[0] = ($event: any) => (isLoading.value = false)),
            onLoading: _cache[1] || (_cache[1] = ($event: any) => (isLoading.value = true))
          })
        ])
      ], 512), [
        [_vShow, !isLoading.value]
      ])
    ])
  ]))
}
}

})